import gql from 'graphql-tag';

export const SearchDispatchSummaryMarket = gql`
  query SearchDispatchSummaryMarket($input: DispatchSummaryMarketConnectionInput) {
    searchDispatchSummaryMarket {
      dispatchSummaryMarketConnection(input: $input) {
        totalCount
        edges {
          node {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            dispatchSummaryId
            comment
            airportCode
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
